import styled, { keyframes } from 'styled-components';

const rise = keyframes`
  from { transform: translateY(24px); opacity: 0; }
  to { transform: none; opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 30;
  background: rgba(0, 0, 0, .45);
`;

export const Sheet = styled.div`
  position: fixed;
  z-index: 31;
  display: flex;
  flex-direction: column;
  background: var(--felt-deep);
  box-shadow: 0 -8px 30px rgba(0, 0, 0, .5);
  animation: ${rise} 160ms ease-out;

  @media (orientation: portrait) {
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 82dvh;
    border-radius: 18px 18px 0 0;
    padding-bottom: env(safe-area-inset-bottom);
  }

  @media (orientation: landscape) {
    top: 0;
    right: 0;
    bottom: 0;
    width: min(420px, 60vw);
    padding-right: env(safe-area-inset-right);
    border-radius: 18px 0 0 18px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 6px 16px;
`;

export const Title = styled.h2`
  flex: 1;
  font-size: 17px;
`;

export const Body = styled.div`
  overflow-y: auto;
  padding: 6px 16px 20px;
`;

/** A big card on the left with what you can do with it on the right. */
export const CardLayout = styled.div`
  --card-w: min(38vw, 170px);
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const Details = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Stat = styled.div`
  color: var(--muted);

  & b {
    color: var(--ink);
  }
`;

/** Small cards in a row in a menu (what's attached, what a Pokémon evolved from), each tappable to see full size. */
export const CardRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
  --card-w: 56px;
`;
